import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import { ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'

import PDSIcon from '../PDSIcon/PDSIcon'
import PDSText from '../PDSText/PDSText'

type PathItem = {
  name: string
  route: string
}

type Props = {
  paths: PathItem[]
} & TestIdProps

// A wrapper for Chakra-UI Breadcrumbs
// Look into building the component in house if more flexibility is needed
export default function PDSBreadCrumbs({ paths, testId }: Props): ReactElement {
  return (
    <Breadcrumb
      data-testid={testId}
      separator={<PDSIcon name="chevronRight" color={COLOR.grey500} />}
      fontSize={FONT_SIZE.fs16}
    >
      {paths.map((path, i) => {
        const isCurrentPage = paths.length - 1 === i
        const fontWeight = isCurrentPage ? 'semibold' : 'regular'
        const fontColor = isCurrentPage
          ? COLOR.textPrimary
          : COLOR.textSecondary

        return (
          <BreadcrumbItem
            key={path.name}
            data-testid={testId && `${testId}-${path.name}`}
            isCurrentPage={isCurrentPage}
          >
            <BreadcrumbLink as={Link} to={path.route} color={fontColor}>
              <PDSText weight={fontWeight} size="md">
                {path.name}
              </PDSText>
            </BreadcrumbLink>
          </BreadcrumbItem>
        )
      })}
    </Breadcrumb>
  )
}
